import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./content/report-content.jsx";
import {hasVisibleReportColumns} from "../../../../utils/report-columns.js";

export default function Content({ reportData, data, entity, title, collapsed, printComponentRef, setIsLoading, boName, onOpenModal, tableColumns }){

    return (
        <>
            {reportData && data > 0 && (
                <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setIsLoading}>
                    <div id="filters-print" className="transform !-translate-y-[8.5px]"/>
                    <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full"/>

                    <div className={`w-full ${hasVisibleReportColumns(tableColumns) ? "mt-[25px]" : "mt-[16px]"} print:mt-[0]`}>
                        <ReportContent
                            data={reportData}
                            boName={boName}
                            collapsed={collapsed}
                            onOpenModal={onOpenModal}
                            tableColumns={tableColumns}
                        />
                    </div>
                </PrintTemplate>
            )}
        </>
    )
}